import { useTranslations } from '@vocab/react';
import { Box, Card, Stack, Strong, Text, TextLink } from 'braid-design-system';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { URL_REGISTER_AGENCY_COMPLETE } from 'src/constants/page-urls';
import { META_TITLE_REGISTRATION_COMPLETE } from 'src/constants/pageMetaData';
import { TRACKING_PAGE_DATA_REGISTRATION_COMPLETE } from 'src/constants/pageTrackingData';
import { useConfig } from 'src/hooks/context';
import useTrackPageLoad from 'src/modules/AnalyticsTracker/useTrackPageLoad';
import PageHeading from 'src/views/shared/PageHeading/PageHeading';
import SeoMeta from 'src/views/shared/SeoMeta/SeoMeta';

import translations from './.vocab';

const AgencyRegistrationCompletePage = () => {
  const location = useLocation();
  const { t } = useTranslations(translations);
  const { absoluteEmployerUrlResolver } = useConfig();
  const fullUrl = absoluteEmployerUrlResolver(URL_REGISTER_AGENCY_COMPLETE);

  useTrackPageLoad(TRACKING_PAGE_DATA_REGISTRATION_COMPLETE);
  useEffect(() => {
    const signOutCsUser = async () => {
      window.location.assign('/oauth/logout/');
    };

    window.setTimeout(signOutCsUser, 20000);
  });

  let email = t('Register agency user email address');

  if (location.state) {
    email = location.state.registeredUserDetails.email;
  }

  return (
    <>
      <SeoMeta
        title={META_TITLE_REGISTRATION_COMPLETE}
        description=""
        url={fullUrl}
      />
      <Box paddingX="gutter">
        <PageHeading title={t('Almost done')} />

        <Card>
          <Stack space="medium">
            <Text component="p">
              {t('Sent activation email message')}{' '}
              <Strong data={{ 'dd-privacy': 'mask', 'hj-masked': true }}>
                {email}
              </Strong>
              .
            </Text>
            <Text component="p">
              {t('Need verification action to activate message')}
            </Text>
            <Box paddingTop="large">
              <Text component="p">
                {t('Sign out and close browser tab message', {
                  Link: (children) => (
                    <TextLink href="/oauth/logout">{children}</TextLink>
                  ),
                })}
              </Text>
            </Box>
          </Stack>
        </Card>
      </Box>
    </>
  );
};

export default AgencyRegistrationCompletePage;
